module.exports = __webpack_public_path__ + "img/limit_resend.e20907e0.png";